import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _toConsumableArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import MuiPaper from '@mui/material/Paper';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiDivider from '@mui/material/Divider';
import { getCookie } from 'docs/src/modules/utils/helpers';
import { useUserLanguage, useTranslate } from '@mui/docs/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function fetchNotifications() {
  return _fetchNotifications.apply(this, arguments);
}
function _fetchNotifications() {
  _fetchNotifications = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var items, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!false) {
            _context2.next = 5;
            break;
          }
          _context2.next = 3;
          return import('../../../notifications.json');
        case 3:
          items = _context2.sent["default"];
          return _context2.abrupt("return", items);
        case 5:
          _context2.next = 7;
          return fetch('https://raw.githubusercontent.com/mui/material-ui/master/docs/notifications.json');
        case 7:
          response = _context2.sent;
          return _context2.abrupt("return", response.json());
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchNotifications.apply(this, arguments);
}
var Paper = styled(MuiPaper)({
  transformOrigin: 'top right',
  backgroundImage: 'none'
});
var List = styled(MuiList)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: theme.spacing(40),
    maxHeight: 540,
    overflow: 'auto',
    padding: theme.spacing(1, 0)
  };
});
var ListItem = styled(MuiListItem)({
  display: 'flex',
  flexDirection: 'column'
});
var Loading = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(3, 0)
  };
});
var Divider = styled(MuiDivider)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    margin: theme.spacing(1, 0)
  };
});
export default function Notifications() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    tooltipOpen = _React$useState4[0],
    setTooltipOpen = _React$useState4[1];
  var anchorRef = React.useRef(null);
  var t = useTranslate();
  var userLanguage = useUserLanguage();
  var _React$useState5 = React.useState({
      lastSeen: 0,
      messages: undefined
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    _React$useState6$ = _React$useState6[0],
    lastSeen = _React$useState6$.lastSeen,
    messages = _React$useState6$.messages,
    setNotifications = _React$useState6[1];
  var messageList = messages ? messages.filter(function (message) {
    if (message.userLanguage && message.userLanguage !== userLanguage && message.userLanguage !== navigator.language.substring(0, 2)) {
      return false;
    }
    return true;
  }).reverse() : null;
  var handleToggle = function handleToggle() {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
    setTooltipOpen(false);
    if (false) {
      // Skip last seen logic in dev to make editing notifications easier.
      return;
    }
    if (messageList && messageList.length > 0) {
      var newLastSeen = messageList[0].id;
      setNotifications(function (notifications) {
        if (newLastSeen !== notifications.lastSeen) {
          return {
            messages: notifications.messages,
            lastSeen: newLastSeen
          };
        }
        return notifications;
      });
      document.cookie = "lastSeenNotification=".concat(newLastSeen, ";path=/;max-age=31536000");
    }
  };
  React.useEffect(function () {
    var active = true;

    // Prevent search engines from indexing the notification.
    if (/glebot/.test(navigator.userAgent) || messages) {
      return undefined;
    }

    // Soften the pressure on the main thread
    // and create some distraction.
    var timeout = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var notifications, filteredNotifications, seen, lastSeenNotification;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchNotifications()["catch"](function () {
              // Swallow the exceptions, for example rate limit
              return [];
            });
          case 2:
            notifications = _context.sent;
            if (active) {
              // Permanent notifications
              filteredNotifications = [
              /* {
                id: 0,
                title: "Let's translate!",
                text: '<a style="color: inherit;" target="_blank" rel="noopener" data-ga-event-category="l10n" data-ga-event-action="notification" data-ga-event-label="zh" href="https://crowdin.com/project/material-ui-docs">帮助 MUI 将文档翻译成中文</a>. 🇨🇳',
                userLanguage: 'zh',
              }, */
              {
                id: 1,
                text: 'You can <a style="color: inherit;" target="_blank" rel="noopener" href="https://x.com/MUI_hq">follow us on X</a> or subscribe on <a style="color: inherit;" target="_blank" rel="noopener" href="/blog/">our blog</a> to receive exclusive tips and updates about MUI and the React ecosystem.'
              }].concat(_toConsumableArray(notifications.splice(-3)));
              seen = getCookie('lastSeenNotification');
              lastSeenNotification = seen === undefined ? 0 : parseInt(seen, 10);
              setNotifications({
                messages: filteredNotifications,
                lastSeen: lastSeenNotification
              });
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), 1500);
    return function () {
      clearTimeout(timeout);
      active = false;
    };
  }, [messages]);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      open: tooltipOpen,
      title: t('toggleNotifications'),
      enterDelay: 300,
      onOpen: function onOpen() {
        setTooltipOpen(!open);
      },
      onClose: function onClose() {
        setTooltipOpen(false);
      },
      children: /*#__PURE__*/_jsx(IconButton, {
        color: "primary",
        size: "small",
        ref: anchorRef,
        "aria-controls": open ? 'notifications-popup' : undefined,
        "aria-haspopup": "true",
        "aria-label": "".concat(messageList ? messageList.reduce(function (count, message) {
          return message.id > lastSeen ? count + 1 : count;
        }, 0) : 0, " ").concat(t('unreadNotifications')),
        "data-ga-event-category": "AppBar",
        "data-ga-event-action": "toggleNotifications",
        onClick: handleToggle,
        children: /*#__PURE__*/_jsx(Badge, {
          color: "error",
          badgeContent: messageList ? messageList.reduce(function (count, message) {
            return message.id > lastSeen ? count + 1 : count;
          }, 0) : 0,
          children: /*#__PURE__*/_jsx(NotificationsNoneRoundedIcon, {
            fontSize: "small"
          })
        })
      })
    }), /*#__PURE__*/_jsx(Popper, {
      id: "notifications-popup",
      anchorEl: anchorRef.current,
      open: open,
      placement: "bottom-end",
      transition: true,
      disablePortal: true,
      role: undefined,
      children: function children(_ref5) {
        var TransitionProps = _ref5.TransitionProps;
        return /*#__PURE__*/_jsx(ClickAwayListener, {
          onClickAway: function onClickAway() {
            setOpen(false);
          },
          children: /*#__PURE__*/_jsx(Grow, _extends({
            "in": open
          }, TransitionProps, {
            children: /*#__PURE__*/_jsx(Paper, {
              sx: function sx(theme) {
                return _extends({
                  mt: 0.5,
                  border: '1px solid',
                  borderColor: 'grey.200',
                  boxShadow: "0px 4px 20px rgba(170, 180, 190, 0.3)"
                }, theme.applyDarkStyles({
                  borderColor: 'primaryDark.700',
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)"
                }));
              },
              children: /*#__PURE__*/_jsx(List, {
                children: messageList ? messageList.map(function (message, index) {
                  return /*#__PURE__*/_jsxs(React.Fragment, {
                    children: [/*#__PURE__*/_jsxs(ListItem, {
                      alignItems: "flex-start",
                      children: [/*#__PURE__*/_jsx(Typography, {
                        gutterBottom: true,
                        children: /*#__PURE__*/_jsx("b", {
                          children: message.title
                        })
                      }), /*#__PURE__*/_jsx(Typography, {
                        gutterBottom: true,
                        variant: "body2",
                        sx: {
                          color: 'text.secondary'
                        },
                        children: /*#__PURE__*/_jsx("span", {
                          id: "notification-message"
                          // eslint-disable-next-line react/no-danger
                          ,
                          dangerouslySetInnerHTML: {
                            __html: message.text
                          }
                        })
                      }), message.date && /*#__PURE__*/_jsx(Typography, {
                        variant: "caption",
                        sx: {
                          color: 'text.secondary'
                        },
                        children: new Date(message.date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })
                      })]
                    }), index < messageList.length - 1 ? /*#__PURE__*/_jsx(Divider, {}) : null]
                  }, message.id);
                }) : /*#__PURE__*/_jsx(Loading, {
                  children: /*#__PURE__*/_jsx(CircularProgress, {
                    size: 32
                  })
                })
              })
            })
          }))
        });
      }
    })]
  });
}